import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const FormLocalisationWrapper = ({ children, touched, setTouched }) => {
    const { i18n } = useTranslation();
    const selectedLanguage = i18n.language;
    /**
     * Touch the fields which have been previously used in the form to
     * re-render error messages in the selected language
     */
    useEffect(() => {
        if (touched && setTouched) {
            setTouched({ ...touched });
        }
    }, [selectedLanguage]);

    return children;
};

export default FormLocalisationWrapper;
